import { gql } from 'graphql-tag'

export const fetchStationsList = gql`
  query FetchStationList($after: String, $first: Int) {
    stations(after: $after, first: $first) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`
export const getAnswersByStationDateAndQuestion = gql`
  query GetAnswersByStationDateAndQuestion($stationId: ID!, $question: String!, $month: Int!, $year: Int!) {
    getAnswersByStationDateAndQuestion(stationId: $stationId, question: $question, month: $month, year: $year) {
      answer
      date
      user {
        name
      }
      station {
        name
      }
    }
  }
`
export const getAnsweredQuestionsByStationAndDate = gql`
  query GetAnsweredQuestionsByStationAndDate($stationId: ID!, $month: Int!, $year: Int!) {
    getAnsweredQuestionsByStationAndDate(stationId: $stationId, month: $month, year: $year) {
      question
    }
  }
`

export const fetchFeelingMeterNotes = gql`
  query FetchFeelingMeterNotes($companyId: ID, $stationId: ID, $year: Int, $month: Int) {
    reportFeelingMeterNotes(companyId: $companyId, stationId: $stationId, year: $year, month: $month) {
      date
      note
      user {
        name
      }
      station {
        name
      }
    }
  }
`

export const fetchCompaniesList = gql`
  query FetchCompaniesList {
    companies {
      id
      name
      stations {
        id
        name
      }
    }
  }
`

export const fetchStationsOfCompany = gql`
  query FetchStationsOfCompany($companyId: ID!) {
    stationsOfCompany(companyId: $companyId) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`

export const exportFeelingMeterNotes = gql`
  mutation ExportFeelingMeterNotes($companyId: ID, $stationId: ID, $year: Int, $month: Int) {
    exportFeelingMeterNotes(companyId: $companyId, stationId: $stationId, year: $year, month: $month)
  }
`
